export default __webpack_public_path__ + "668a694e90a0ec63f446ecc8807094b6.png";